import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Toast } from 'primeng/toast';
import { LayoutService } from './layout/service/layout.service';
import { GlobalNavLoaderComponent } from '@core/functions/global-nav-loader.component';
import { CookieConsentComponent } from '@shared/components/cookie-consent/cookie-consent.component';

@Component({
  selector: 'd2d-root',
  imports: [RouterOutlet, Toast, GlobalNavLoaderComponent, CookieConsentComponent],
  template: `
    <router-outlet></router-outlet>
    <d2d-global-nav-loader />
    <p-toast />
    <d2d-cookie-consent />
  `,
})
export class AppComponent {
  private readonly layoutService = inject(LayoutService);

  constructor() {
    this.layoutService.applyConfig();
  }
}
